import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import HotFeature005 from '../../../../assets/HotFeature005.png';
import {
  BACKGROUND_BLACK,
  ORANGE,
  WHITE,
  LIGHT_BLUE,
} from '../../../../styles/Colors';
import { HEADER_HIGHT } from '../../../../styles/LayoutSetting';
import {
  mobileDevice,
  largeDevice,
} from '../../../../constants/DeviceBreakPoints';
import {
  Mobile,
  Default,
} from '../../../../components/MediaQueryComponent';

const styles = theme => ({
  screenContainer: {
    backgroundColor: BACKGROUND_BLACK,
    padding: '10px 20px',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up(largeDevice)]: {
      padding: '40px 20px 10px 20px',
    },
  },
  wrapperContainer: {
    width: '100%',
    maxWidth: 1400,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: `calc((100vh - ${HEADER_HIGHT}px)*0.8)`,
    [theme.breakpoints.up(largeDevice)]: {
      maxHeight: 900,
      minHeight: `calc((100vh - ${HEADER_HIGHT}px)*0.8)`,
    },
    [theme.breakpoints.down(mobileDevice)]: {
      height: 'auto',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      margin: '10px 20px',
    },
  },
  imageContainer: {
    flex: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: 10,
  },
  imageText: {
    fontFamily: 'Quicksand, sans-serif',
    color: LIGHT_BLUE,
    fontSize: 16,
    textAlign: 'center',
    margin: 10,
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 12,
    },
  },
  imageRowContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  imageContentContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  imageStyle: {
    width: '100%',
    height: '90%',
    maxHeight: 400,
    objectFit: 'contain',
    [theme.breakpoints.up(largeDevice)]: {
      maxHeight: `calc((100vh - ${HEADER_HIGHT}px)*0.8)`,
      margin: 10,
    },
  },
  textContainer: {
    flex: 1,
    padding: '0 20px',
  },
  titleText: {
    fontFamily: 'Poppins, sans-serif',
    color: ORANGE,
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: 1.2,
    padding: '8px 0',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 18,
      textAlign: 'center',
    },
  },
  descriptionContainer: {
    margin: '10px 0',
    [theme.breakpoints.down(mobileDevice)]: {
      margin: '4px 0',
    },
  },
  descriptionText: {
    fontFamily: 'Quicksand, sans-serif',
    color: WHITE,
    fontSize: 18,
    textAlign: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
    },
  },
  highlightText: {
    color: ORANGE,
  },
});

const HotFeatureSection = ({
  classes,
}) => {
  const ImageTitle = (
    <div className={classes.imageRowContainer}>
      <div className={classes.imageText}>
        COVID19 Questionnaire
      </div>
      <div className={classes.imageText}>
        Signature / Accountability
      </div>
    </div>
  );
  const ImagesRow = (
    <div className={classes.imageContentContainer}>
      <div className={classes.imageText}>
        Germ - free Sign In
      </div>
      <img
        alt="HotFeature005"
        src={HotFeature005}
        className={classes.imageStyle}
      />
    </div>
  );
  const SubTitle = (
    <div className={classes.titleText}>
      Germ - Free QR Code & COVID - 19 Sign In
    </div>
  );
  const DescriptionText = (
    <React.Fragment>
      <div className={classes.descriptionContainer}>
        <span className={classes.descriptionText}>
          {[
            'VIRTUAL PROJECT MANAGER manages sign-in sheets for your morning huddles,',
            'project meetings, safety talks, etc. With unique QR codes, ',
          ].join(' ')}
        </span>
        <span className={`${classes.descriptionText} ${classes.highlightText}`}>
          {[
            'workers can sign in (germ free) with their own smartphone’s camera. ',
          ].join(' ')}
        </span>
        <span className={classes.descriptionText}>
          {[
            'QR codes can be printed and posted around the job site',
            'to make the sign-in process efficient and socially distance safe.',
          ].join(' ')}
        </span>
      </div>
      <div className={classes.descriptionContainer}>
        <span className={classes.descriptionText}>
          {[
            'Not to mention, you can ',
          ].join(' ')}
        </span>
        <span className={`${classes.descriptionText} ${classes.highlightText}`}>
          {[
            'sign in ALL workers in seconds. ',
          ].join(' ')}
        </span>
        <span className={classes.descriptionText}>
          {[
            'Have workers answer COVID-19 questionnaires and collect signatures germ-free for accountability.',
          ].join(' ')}
        </span>
      </div>
      <div className={classes.descriptionContainer}>
        <span className={classes.descriptionText}>
          {[
            'A log is kept of every sign-in so if an incident occurs',
            'you have the information at your fingertips and can do a ',
          ].join(' ')}
        </span>
        <span className={`${classes.descriptionText} ${classes.highlightText}`}>
          {[
            'contact tracing anaylsis to ensure worker health.',
          ].join(' ')}
        </span>
      </div>
    </React.Fragment>
  );
  return (
    <div className={classes.screenContainer}>
      <Mobile>
        <div className={classes.wrapperContainer}>
          {SubTitle}
          <div className={classes.imageContainer}>
            {ImagesRow}
            {ImageTitle}
          </div>
          {DescriptionText}
        </div>
      </Mobile>
      <Default>
        <div className={classes.wrapperContainer}>
          <div className={classes.textContainer}>
            {SubTitle}
            {DescriptionText}
          </div>
          <div className={classes.imageContainer}>
            {ImagesRow}
            {ImageTitle}
          </div>
        </div>
      </Default>
    </div>
  );
};

HotFeatureSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HotFeatureSection);
